export class ActionTypeText {
    addToCartText='ADDTOCART'
    isMarkSpencer='IS_MARK_SPENCER'
    counteryCodeValue='COUNTERY_CODE_VALUE'
    isFullScreen='IS_FULL_SCREEN'
}